@if (loaded) {
  <azavista-table [dataSource]="data" [columns]="columns" [displayedColumns]="displayedColumns"
    [compactControls]="true"
    [pagingOptions]="pagingOptions">
  </azavista-table>
}
